<template>
    <div>
        <button class="btn btn-primary" @click.prevent="handleClick">
            Add to calendar
        </button>
    </div>
</template>

<script setup>
import { createEvent } from 'ics';

const props = defineProps({
    start: Date,
    end: Date,
    title: String,
    description: String,
    location: String,
    status: {
        type: String,
        default: "CONFIRMED"
    },
    url: String
})

function getDateArray(date) {
    return [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes()];
}

function handleClick() {
    window.dataLayer.push({'event': 'getInto_registration_calendar_invite_button'});
    const {value: event} = createEvent({
        title: props.title,
        description: props.description,
        start: getDateArray(props.start),
        end: getDateArray(props.end),
        location: props.location,
        status: props.status,
        url: props.url,
        productId: 'princes-trust'
    });

    const anchor = document.createElement('a');
    anchor.setAttribute('href', 'data:text/calendar;charset=utf-8,' + encodeURIComponent(event));
    anchor.setAttribute('download', 'info-session.ics');

    anchor.style.display = 'none';
    document.body.appendChild(anchor);

    anchor.click();
    document.body.removeChild(anchor);
}
</script>
